import { Button } from "@mui/material";
import { CSVCountCheckStock, SupplierStockSingle } from "../types";
import SupplierConfirmTable from "./SupplierConfirmTable";
import { dispSymbol } from "../utils/common";
import { amountSymbolsWithNoStock } from "../constants";

type Props = {
  open: boolean;
  onClose: Function;
  onUpdate: Function;
  changedStockList: SupplierStockSingle[];
  isUpdateProcessing: boolean;
  isSupplier?: boolean; // CSVではないupdateの時のみ仕入先ユーザーであればisSupplierに入力
  selectHeaderCenterWarehouse?: () => JSX.Element; // ヘッダーでセンター倉庫を選ぶ要素
  selectHeaderRegionWarehouse?: () => JSX.Element; // 近隣倉庫を選ぶ要素
  bodyCenterWarehouse?: (id: string) => JSX.Element; // 選ばれたときの対象のセンター倉庫数量
  bodyRegionWarehouse?: (id: string) => JSX.Element; // 選ばれたときの対象の近隣倉庫数量
};



/**
 * 在庫数量更新確認モーダル
 * @param root0 コンポーネントのプロップス
 * @returns JSX.Element
 */
export default function StockUpdateConfirmDialog({
  open,
  onClose,
  onUpdate,
  changedStockList,
  isUpdateProcessing,
  isSupplier,
  selectHeaderCenterWarehouse,
  selectHeaderRegionWarehouse,
  bodyCenterWarehouse,
  bodyRegionWarehouse,
}: Props) {

  const singleToCsv = (list: SupplierStockSingle[]): CSVCountCheckStock[] => list.map(s => {
    const am = dispSymbol(s.amountCount, s.stockVisibleType, s.symbolThresholdList);
    return {
      id: s.id,
      productCd: s.productCd,
      JANCd: s.JANCd,
      amount: (am !== amountSymbolsWithNoStock[4]) ? am : s.amountCount,
      arrivalDate: s.arrivalDate,
    }
  });
  const ActionButtons = (
    <>
      {/* <Button variant="outlined" color="error" onClick={() => onReset()}>
        数量リセット
      </Button> */}
      <Button variant="custom-outlined" onClick={() => onClose()}>
        キャンセル
      </Button>
      <Button variant="contained" onClick={() => onUpdate()} disabled={isUpdateProcessing}>
        更新
      </Button>
    </>
  );
  return (
    <SupplierConfirmTable open={open} onClose={onClose} stockList={singleToCsv(changedStockList)} ActionButtons={ActionButtons} title="数量の更新" content="以下の数量を更新します。よろしいですか？"
      isSupplier={isSupplier}
      selectHeaderCenterWarehouse={selectHeaderCenterWarehouse}
      selectHeaderRegionWarehouse={selectHeaderRegionWarehouse}
      bodyCenterWarehouse={bodyCenterWarehouse}
      bodyRegionWarehouse={bodyRegionWarehouse}
    />
  );
}